<template lang="pug">
  .ai-panel
    .chart-toolbar
      .dropdown-filters
        .dropdown-filter
          source-type-filter(v-model="selectedSourceTypes")
      .time-range-filter
        aiq-date-picker(v-model="dateRange"
                        type="daterange"
                        placeholder="Select date range"
                        popper-class="metrics-time-range__date-picker-popup"
                        :shortcuts="datePickerOptions.shortcuts"
                        :disabled-date="datePickerOptions.disabledDate"
                        :teleported="false"
                        format="YYYY/MM/DD"
                        :clearable="false"
                        :default-time="getDatePickerDefaultTime()")
    .ai-panel__sections
      aiq-collapse(v-model="openSections")
        aiq-collapse-item(:title="$t(`${I18N_PREFIX}.overview_tab.title`)" name="overview")
          smart-assist-overview(v-if="rendered.overview"
                                :date-range="dateRange"
                                :filters="selectedFilters")
        aiq-collapse-item(:title="$t(`${I18N_PREFIX}.questions_tab.title`)" name="questions")
          smart-assist-questions(v-if="rendered.questions"
                                 :date-range="dateRange"
                                 :filters="selectedFilters")
        aiq-collapse-item(:title="$t(`${I18N_PREFIX}.documents_tab.title`)" name="documents")
          smart-assist-documents(v-if="rendered.documents"
                                 :date-range="dateRange"
                                 :filters="selectedFilters")
</template>

<script>
import {
  datePickerDefaultOptions,
  defaultDateRange,
  lastAvailableMonthAndQuarterRange,
  createPickerDateRangeOption,
} from '../../configs/dateRange';
import SmartAssistOverview from './Overview.vue';
import SmartAssistQuestions from './Questions.vue';
import SmartAssistDocuments from './Documents.vue';
import SourceTypeFilter from './SourceTypeFilter.vue';

const I18N_PREFIX = 'metrics_tab.smart_assist_tab';
const DEFAULT_OPEN = 'overview';

export default {
  name: 'SmartAssistPanel',
  pageResource: '/metrics',
  components: {
    SmartAssistOverview,
    SmartAssistQuestions,
    SmartAssistDocuments,
    SourceTypeFilter,
  },
  data() {
    return {
      I18N_PREFIX,
      dateRange: defaultDateRange(),
      selectedSourceTypes: [],
      openSections: [DEFAULT_OPEN],
      rendered: { [DEFAULT_OPEN]: true },
    };
  },
  computed: {
    // Shaped here so each section receives filters ready for `getMetric`.
    selectedFilters() {
      return this.selectedSourceTypes.length
        ? [{ source_type: this.selectedSourceTypes }]
        : [];
    },
    datePickerOptions() {
      return {
        ...datePickerDefaultOptions(),
        shortcuts: lastAvailableMonthAndQuarterRange.map(createPickerDateRangeOption),
      };
    },
  },
  watch: {
    openSections(names) {
      names.forEach(name => {
        this.rendered[name] = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./aiPanel.scss";
</style>
